import styled, { css } from 'styled-components';

import { Flex } from '@/components/Flex';
import type { ContentfulCardFragment } from '@/graphql/contentful/api';

import {
  getContentAlignment,
  getTextAlignment,
  visibilityControl,
} from '../../Card.styles';

export const Wrapper = styled(Flex)<
  Pick<
    ContentfulCardFragment,
    | 'contentAlignment'
    | 'mediaAnimationEffect'
    | 'visibleInDesktop'
    | 'visibleInMobile'
  > & {
    $hasBackgroundImage: boolean;
    $heroCard: boolean;
  }
>`
  position: relative;
  overflow: hidden;
  height: inherit;
  ${({ visibleInDesktop, visibleInMobile }) => css`
    ${visibilityControl(visibleInDesktop, visibleInMobile)}
  `};
  ${({
    $hasBackgroundImage,
    $heroCard,
    contentAlignment,
    mediaAnimationEffect,
    theme,
  }) => css`
    ${mediaAnimationEffect &&
    css`
      &:hover {
        cursor: pointer;
        img {
          transform: scale(1.1);
          transition: all 0.5s linear;
        }
      }
    `}

    padding: ${theme.spacing(8, 2)};
    color: ${$hasBackgroundImage ? theme.colors.white : theme.colors.black};

    ${theme.media.md.up} {
      ${$heroCard
        ? css`
            padding: ${({ theme }) =>
              theme.components.heroBanner.title.padding};
          `
        : css`
            padding: ${({ theme }) => theme.spacing(5)} 5%;
          `}
      ${getContentAlignment(contentAlignment)};
    }

    ${theme.media.lg.up} {
      ${$heroCard
        ? css`
            padding-inline: ${theme.components.heroBanner.title.padding};
          `
        : css`
            padding-inline: 10%;
          `}
    }

    ${theme.media.md.down} {
      ${$heroCard
        ? css`
            justify-content: center;
            align-items: flex-end;
          `
        : css`
            ${getContentAlignment(contentAlignment)}
          `}
    }
  `};
`;

export const Content = styled(Flex)<
  Pick<ContentfulCardFragment, 'textAlignment'> & {
    $isCountDown?: boolean | null;
  }
>`
  flex-direction: column;
  max-width: 400px;
  word-break: break-word;
  white-space: pre-wrap;
  z-index: 2;

  ${({ $isCountDown, textAlignment, theme }) => css`
    font-size: ${theme.fontSizes.p2};

    ${theme.media.md.down} {
      margin: 0 auto;
      ${getTextAlignment('Center')}
    }

    ${theme.media.md.up} {
      max-width: ${$isCountDown ? '800px' : '500px'};
      justify-content: center;
      ${getTextAlignment(textAlignment)}
    }

    ${theme.media.lg.up} {
      max-width: ${$isCountDown ? '800px' : '550px'};
      justify-content: center;
      ${getTextAlignment(textAlignment)}
    }
  `}
`;

export const VideoPlayButtonRoot = styled.div`
  opacity: 0;
  &.show {
    opacity: 1;
  }
`;

export const LoaderOverlay = styled.div`
  position: absolute;
  inset: 0;
  z-index: 1;
  pointer-events: none;
`;
